/** PLP Scroll Tracking
 * Saves scroll position on collection pages when a user clicks a product link.
 * Restores scroll position when the user navigates back from PDP and after browsing through color variant products.
 */
(function () {
  var KEY_SCROLL_Y = 'PLP_SCROLL_Y';
  var KEY_RESTORE = 'PLP_RESTORE_SCROLL';

  // --- Restore ---
  var savedScrollY = localStorage.getItem(KEY_RESTORE) && localStorage.getItem(KEY_SCROLL_Y);
  localStorage.removeItem(KEY_RESTORE);

  if (savedScrollY) {
    var targetY = parseInt(savedScrollY, 10);
    var app = document.getElementById('search-app');
    if (app) {
      var done = false;
      var scroll = function () {
        if (done) return;
        if (app.children.length > 0 && document.body.scrollHeight >= targetY) {
          done = true;
          window.scrollTo({ top: targetY, left: 0, behavior: 'instant' });
          observer.disconnect();
        }
      };
      var observer = new MutationObserver(scroll);
      observer.observe(app, { childList: true, subtree: true });
      window.addEventListener('load', scroll);
      setTimeout(function () { if (!done) { done = true; window.scrollTo({ top: targetY, left: 0 }); observer.disconnect(); } }, 3000);
    }
  }

  // --- Save on product link click ---
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (link && link.getAttribute('href')) {
      localStorage.setItem(KEY_SCROLL_Y, String(window.scrollY));
    }
  });
})();
